var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var _this = this;
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { MESSAGETYPES, sendToHost } from 'conversional-iframe-communication';
import { addCallbacks, publish } from 'conversional-callbacks';
import { Events, TrackingActions, useAppDispatch } from 'conversional-journey';
import { exitIntentConfig } from 'conversional-environment';
import { ENGINES, getItem, setItem } from 'conversional-persistent-storage';
import ExitIntentMobileComponent from './ExitIntentMobileComponent';
//TODO: Add callback event listeners
var TIME_TO_LIVE = 86400000;
var STORAGE_ENGINE = ENGINES.LOCAL_STORAGE;
var ExitIntentMobileContainer = function (_a) {
    var callbacks = _a.callbacks, componentKey = _a.componentKey, onClose = _a.onClose, onTrigger = _a.onTrigger, onClick = _a.onClick, exitIntentMobileComponentProps = __rest(_a, ["callbacks", "componentKey", "onClose", "onTrigger", "onClick"]);
    var flag = "".concat(exitIntentConfig.HIDE_FLAG);
    var _b = React.useState(true), hidden = _b[0], setHide = _b[1];
    var dispatch = useAppDispatch();
    var trackEvent = function (event) { return dispatch(TrackingActions.event(event)); };
    var exitIntentShouldShow = function () {
        if (getItem(flag, {}, STORAGE_ENGINE) === 'true') {
            return false;
        }
        return true;
    };
    React.useEffect(function () {
        if (!exitIntentShouldShow()) {
            onClose();
            setHide(true);
            return;
        }
        var timeout = setTimeout(function () {
            setHide(false);
            // Internal Callbacks within iframe
            var supportedCallbacks = {
                onClickCallback: click,
                onCloseCallback: hidePermanently,
                onTriggerCallback: trigger,
            };
            addCallbacks(_this, callbacks || {}, supportedCallbacks);
            // Listen to host events
            var cb1 = sendToHost.subscribe(MESSAGETYPES.ON_EXITMOBILE, trigger);
            return function () {
                sendToHost.unsubscribe(MESSAGETYPES.ON_EXITMOBILE, trigger);
            };
        }, exitIntentConfig.DELAY_TO_ACTIVATE);
        return function () {
            clearTimeout(timeout);
        };
    }, []);
    var hidePermanently = function () {
        setItem(flag, 'true', { ttl: TIME_TO_LIVE }, STORAGE_ENGINE);
        setHide(true);
        publish("ExitIntentMobile.closed.".concat(componentKey));
        trackEvent(Events.EXITINTENTMOBILE_CLOSE);
        onClose();
    };
    var trigger = function () {
        if (!exitIntentShouldShow()) {
            return;
        }
        publish("ExitIntentMobile.shown.".concat(componentKey));
        trackEvent(Events.EXITINTENTMOBILE_SHOW);
        onTrigger();
    };
    var click = function () {
        onClick();
        hidePermanently();
        publish("ExitIntentMobile.clicked.".concat(componentKey));
        trackEvent(Events.EXITINTENTMOBILE_OPEN);
    };
    return (_jsx(ExitIntentMobileComponent, __assign({ activate: function () { return setHide(true); }, close: hidePermanently, open: click, displayOnScroll: !hidden }, exitIntentMobileComponentProps)));
};
export default (ExitIntentMobileContainer);
